import { ReactNode } from 'react'

import { ContentModuleType, Event } from '@tribeplatform/gql-client/types'
import { useRouter } from '@tribeplatform/react-sdk'

import { useActiveContentModule } from '../../../common/index.js'

interface Props {
  children: ReactNode
  event: Event
  className?: string
}
export const EventItemWrapper = ({ children, event, className }: Props) => {
  const { Link } = useRouter()
  const { setActiveContentModule } = useActiveContentModule()
  const onClick = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    setActiveContentModule(ContentModuleType.event, event.id)
  }
  return (
    <Link
      variant="inherit"
      href={event.relativeUrl}
      onClick={onClick}
      className={className}
    >
      {children}
    </Link>
  )
}
